import React, { useState, useEffect } from 'react';
import API from '../api';

const emptyForm = { firstName: '', lastName: '', specialization: '' };

const DoctorsPanel = () => {
    const [doctors, setDoctors] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [newDoctor, setNewDoctor] = useState(emptyForm);
    const [editingId, setEditingId] = useState(null);
    const [editValues, setEditValues] = useState(emptyForm);

    useEffect(() => {
        fetchDoctors();
    }, []);

    const fetchDoctors = async () => {
        try {
            const res = await API.get('/doctors');
            setDoctors(res.data);
        } catch (err) {
            console.error("Greška pri učitavanju doktora", err);
        }
    };

    const handleNewChange = (e) => {
        setNewDoctor({ ...newDoctor, [e.target.name]: e.target.value });
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        try {
            await API.post('/doctors', newDoctor);
            setNewDoctor(emptyForm);
            setShowForm(false);
            fetchDoctors();
        } catch (err) {
            alert("Greška pri dodavanju doktora!");
        }
    };

    const startEdit = (doctor) => {
        setEditingId(doctor.id);
        setEditValues({
            firstName: doctor.firstName,
            lastName: doctor.lastName,
            specialization: doctor.specialization ?? ''
        });
    };

    const cancelEdit = () => {
        setEditingId(null);
        setEditValues(emptyForm);
    };

    const handleEditChange = (e) => {
        setEditValues({ ...editValues, [e.target.name]: e.target.value });
    };

    const saveEdit = async (id) => {
        try {
            await API.put(`/doctors/${id}`, editValues);
            cancelEdit();
            fetchDoctors();
        } catch (err) {
            alert("Greška pri izmeni doktora!");
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h2 style={styles.title}>Doktori</h2>
                <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
                    {showForm ? 'Zatvori' : '+ Novi doktor'}
                </button>
            </div>

            {showForm && (
                <form onSubmit={handleCreate} style={styles.form}>
                    <input name="firstName" placeholder="Ime" value={newDoctor.firstName} onChange={handleNewChange} required style={styles.input} />
                    <input name="lastName" placeholder="Prezime" value={newDoctor.lastName} onChange={handleNewChange} required style={styles.input} />
                    <input name="specialization" placeholder="Specijalizacija (opciono)" value={newDoctor.specialization} onChange={handleNewChange} style={styles.input} />
                    <button type="submit" style={styles.saveBtn}>Sačuvaj</button>
                </form>
            )}

            <div style={styles.listWrapper}>
                {doctors.length > 0 ? (
                    doctors.map(d => (
                        <div key={d.id} style={styles.row}>
                            {editingId === d.id ? (
                                <>
                                    <div style={styles.editFields}>
                                        <input name="firstName" placeholder="Ime" value={editValues.firstName} onChange={handleEditChange} style={styles.editInput} />
                                        <input name="lastName" placeholder="Prezime" value={editValues.lastName} onChange={handleEditChange} style={styles.editInput} />
                                        <input name="specialization" placeholder="Specijalizacija" value={editValues.specialization} onChange={handleEditChange} style={styles.editInput} />
                                    </div>
                                    <div style={styles.actions}>
                                        <button onClick={() => saveEdit(d.id)} style={styles.saveSmallBtn}>Sačuvaj</button>
                                        <button onClick={cancelEdit} style={styles.cancelBtn}>Otkaži</button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div style={styles.info}>
                                        <div style={styles.name}>dr {d.firstName} {d.lastName}</div>
                                        {d.specialization && <div style={styles.subtext}>{d.specialization}</div>}
                                    </div>
                                    <div style={styles.actions}>
                                        <button onClick={() => startEdit(d)} style={styles.editBtn}>Izmeni</button>
                                    </div>
                                </>
                            )}
                        </div>
                    ))
                ) : (
                    <div style={{ textAlign: 'center', padding: '30px', color: '#888' }}>
                        Nema unetih doktora.
                    </div>
                )}
            </div>
        </div>
    );
};

const styles = {
    container: {
        maxWidth: '800px',
        margin: '0 auto',
        padding: '15px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
    title: { margin: 0, fontSize: '24px', color: '#1f2937' },
    addBtn: { padding: '10px 15px', backgroundColor: '#27ae60', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' },
    form: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '10px',
        padding: '15px',
        backgroundColor: '#f1f3f5',
        borderRadius: '10px',
        marginBottom: '20px'
    },
    input: { padding: '12px', border: '1px solid #ccc', borderRadius: '6px' },
    saveBtn: { gridColumn: 'span 2', padding: '12px', backgroundColor: '#2980b9', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold' },
    listWrapper: { backgroundColor: 'white', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px',
        borderBottom: '1px solid #eee',
        gap: '10px',
        flexWrap: 'wrap'
    },
    info: { display: 'flex', flexDirection: 'column' },
    name: { fontSize: '17px', fontWeight: '600', color: '#1f2937', marginBottom: '4px', textTransform: 'capitalize' },
    subtext: { fontSize: '13px', color: '#7f8c8d' },
    actions: { display: 'flex', gap: '8px' },
    editBtn: { padding: '8px 12px', backgroundColor: '#f59e0b', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
    saveSmallBtn: { padding: '8px 12px', backgroundColor: '#10b981', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
    cancelBtn: { padding: '8px 12px', backgroundColor: '#94a3b8', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
    editFields: { display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' },
    editInput: { padding: '8px', border: '1px solid #ccc', borderRadius: '6px', width: '160px' }
};

export default DoctorsPanel;
